import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorMasterMenuView = () => {
  const menuView = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/management/master-menu/view', payload, (response) => {
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
      loading(false)
    })
  }, [])

  return { menuView }
}

export default InteractorMasterMenuView
